import { getAuthenticatedFetch } from "../../msal/authenticatedFetchService";
import { UsageTelemetryEnvironmentOption, UsageTelemetryStatus } from "../types/UsageTelemetry";

class UsageTelemetryService {
    async getEnvironments(): Promise<UsageTelemetryEnvironmentOption[]> {
        const url = `${process.env.REACT_APP_SELF_SERVICE_CARECOMPLIANCE_API_URL}/UsageTelemetry/environments`;
        const response = await getAuthenticatedFetch()(url);
        if (!response.ok) {
            throw new Error(`Environments request failed with status ${response.status}`);
        }
        return await response.json();
    }

    async generate(environments: string[]): Promise<{ taskId: string }> {
        const url = `${process.env.REACT_APP_SELF_SERVICE_CARECOMPLIANCE_API_URL}/UsageTelemetry/generate`;
        const response = await getAuthenticatedFetch()(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ environments })
        });
        if (!response.ok) {
            throw new Error(`Request failed with status ${response.status}`);
        }
        return await response.json();
    }

    async getStatus(taskId: string): Promise<UsageTelemetryStatus> {
        const url = `${process.env.REACT_APP_SELF_SERVICE_CARECOMPLIANCE_API_URL}/UsageTelemetry/status?taskId=${encodeURIComponent(taskId)}`;
        const response = await getAuthenticatedFetch()(url);
        if (!response.ok) {
            throw new Error(`Status request failed with status ${response.status}`);
        }
        return await response.json();
    }

    async downloadReport(taskId: string): Promise<{ blob: Blob; filename: string }> {
        const url = `${process.env.REACT_APP_SELF_SERVICE_CARECOMPLIANCE_API_URL}/UsageTelemetry/download?taskId=${encodeURIComponent(taskId)}`;
        const response = await getAuthenticatedFetch()(url);

        if (!response.ok) {
            throw new Error(`Download failed with status ${response.status}`);
        }

        const contentDisposition = response.headers.get('content-disposition');
        let filename = `AccTenantScores_${new Date().toISOString().slice(0, 10)}.xlsx`;
        if (contentDisposition) {
            const utf8Match = /filename\*=UTF-8''([^;]+)/.exec(contentDisposition);
            if (utf8Match && utf8Match[1]) {
                filename = decodeURIComponent(utf8Match[1]);
            } else {
                const plainMatch = /filename="?([^";]+)"?/.exec(contentDisposition);
                if (plainMatch && plainMatch[1]) {
                    filename = plainMatch[1];
                }
            }
        }

        const blob = await response.blob();
        return { blob, filename };
    }
}

export default new UsageTelemetryService();
